

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import FilterLabel from '@/main-components/pre-collections-new/pre-collection-filter/FilterLabel.vue';
import FilterDropdownItem from '@/main-components/pre-collections-new/pre-collection-filter/FilterDropdownItem.vue';
import Divider from '@/components/common/Divider.vue';
import { PreCollectionsParams } from '@/resource/pre-collection/pre-collection.store';

export interface FilterDropdwonOption {
  value: string | number;
  isActive: boolean;
}

@Component({
  components: {
    FilterLabel,
    FilterDropdownItem,
    Divider,
  },
})
export default class FilterDropdown extends Vue {
  @Prop({ default: 'label' })
  label!: string;

  @Prop({ required: true })
  queries!: PreCollectionsParams;

  @Prop({ required: true })
  availOptions!: (number | string)[];

  @Prop({ default: () => [] })
  initSelectedOptions: (number | string)[];

  @Prop({ default: false })
  isMultiSelection!: boolean;

  @Prop()
  resetListener!: string | number | boolean;

  @Prop()
  updateSelected: (option: number | string | (number | string)[]) => void;

  @Prop({ default: null })
  updateValue: (option: number | string) => string;

  @Prop({ default: false })
  isSortByFilter: boolean;

  options: FilterDropdwonOption[] = [];

  selectedOptions: (number | string)[] = [];
  selectedOption: number | string | null = null;

  created() {
    this.updateOptions();
  }

  updateOptions() {
    this.options = this.availOptions.map(availOption => {
      let isActive = false;

      if (
        this.initSelectedOptions &&
        this.initSelectedOptions.includes(availOption)
      ) {
        isActive = true;
      }

      return {
        value: availOption,
        isActive,
      };
    });

    if (this.isMultiSelection) {
      this.selectedOptions = [...this.initSelectedOptions];
    } else {
      this.selectedOption = `${this.initSelectedOptions[0]}`;
    }
  }

  optionClick(option: FilterDropdwonOption, hide: () => void) {
    if (this.isMultiSelection) {
      if (option.isActive) {
        this.selectedOptions.splice(
          this.selectedOptions.indexOf(option.value),
          1,
        );
      } else {
        this.selectedOptions.push(option.value);
      }

      this.updateSelected(this.selectedOptions);
    } else {
      const prevActiveOption = this.options.find(
        opt => opt.value === this.selectedOption,
      );

      if (prevActiveOption) {
        prevActiveOption.isActive = false;
      }

      this.selectedOption = option.value;
      this.updateSelected(this.selectedOption);
    }

    option.isActive = !option.isActive;

    if (hide) {
      hide();
    }
  }

  @Watch('resetListener')
  @Watch('queries.PreCollectionType')
  @Watch('queries.levels')
  @Watch('queries.years')
  onResetListenerChange() {
    this.updateOptions();
  }
}
